import styled from "styled-components";


export const StyledIndication = styled.span<{ isIncome: boolean }>`
  color: ${props => props.isIncome ? props.theme.C_SEM_el_good : props.theme.C_SEM_el_bad}
`;